import axios from "axios";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import Afribrand from "../../assets/images/afriglobal.svg";
import AlertInfo from "../../assets/images/alertInfo.svg";
import Clinixbrand from "../../assets/images/clinix.svg";
import Drop from "../../assets/images/comparedrop.svg";
import OpenDrop from "../../assets/images/compareopen.svg";
import Dnabrand from "../../assets/images/dna.svg";
import Docbrand from "../../assets/images/docbrand.svg";
import Echobrand from "../../assets/images/echo.svg";
import Imagebrand from "../../assets/images/imag.svg";
import Lancetbrand from "../../assets/images/lancet.svg";
import Synlabbrand from "../../assets/images/synlab.svg";
import Unionbrand from "../../assets/images/union.svg";
import LocationList from "./LocationList";
import PriceCompareTests from "./PriceCompareTests";
import { Toast } from "../../components";
import "./styles.scss";
import DoctorProfile from "../../assets/images/Doctor_s Profile.svg";

export default function Pricecard(props) {
  const {
    radiovalue,
    setRadiovalue,
    homeserve,
    totallab,
    setTotallab,
    homeserviceSelectedStatus,
    radiotwo,
    setRadiotwo,
    setCountResult,
    countresult,
    checkoutdisplay,
    setCheckoutdisplay,
    setCartfn,
    radiothree,
    setCheapestcount,
    cheapestcount,
    setCheapestcounttwo,
    setTotalamount,
    totalamount,
    amountarr,
    setAmountarr,
    homearr,
    selectallcard,
    setSelectallcard,
    recommendedTest,
    setHomeAvailable,
    recommendedpartneruuid,
    diagnosticspartner,
  } = props;

  console.log(countresult, "countresult")

  const [availableTest, setAvailableTest] = useState([]);
  const [partnername, setPartnerName] = useState("");
  const [update, setUpdate] = useState(false);
  const [mobileView, setMobileView] = useState(false);
  const [showHomeSample, setShowHomeSample] = useState(false);
  const [showHomeSampleArray, setShowHomeSampleArray] = useState([]);
  // const [accordian, setaccordian] = useState(false);
  const [accordian, setaccordian] = useState(true);

  const [showHomeSamplePopup, setHomeSamplePopUp] = useState(false);
  const [isHomeSampleSelected, setIsHomeSampleSelected] = useState(false);
  const [IsSelectedall, setIsSelectedall] = useState(false);

  const [checkedState, setCheckedState] = useState();
  const [alertInfo, setAlertInfo] = useState(false);

  const [partnerNames, setPartnerNames] = useState("");
  const [locationPopup, setLocationPopup] = useState(false);
  const [locations, setLocations] = useState([]);

  const [partner, setPartner] = useState([]);
  const [addItem, SetAddItem] = useState(false);
  const [addItemText, SetAddItemText] = useState();

  console.log(
    recommendedpartneruuid,
    diagnosticspartner,
    "uuidpartneruuidpartner"
  );
  const areaState = useSelector((state) =>
    state.area != undefined && state.area.area != undefined
      ? state.area.area
      : ""
  );
  const cityState = useSelector((state) =>
    state.city != undefined && state.city.label != undefined ? state.city : ""
  );

  // console.log(recommendedTest.test_uuid)

  // const fetchLocationList = async (partnerName) => {
  //   try {
  //     let response = await axios.get(
  //       `${process.env.REACT_APP_API_URL
  //       }/user/partner/partner/location?lab_partner_name=${partnerName}&city=${cityState && cityState.value
  //       }`
  //     );
  //     setLocations(response.data);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  const fetchLocationList = async (partnerName) => {
    try {
      let response = await axios.get(
        `${process.env.REACT_APP_API_URL}/uploadDoc/labpartner/details?area_uuid=${props.area_uuid}&city_uuid=${props.city_uuid}&partner_uuid=${props.partner_uuid}`
      );
      console.log(response.data, "props.partner_uuid")
      setLocations(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/metadata/partner/getpartner`)
      .then((res) => {
        console.log(res.data, "parternr")
        setPartner(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  var array3 = [];

  for (let i = 0; i < partner.length; i++) {
    console.log(props.partner_uuid, "props.partner_uuid")
    console.log(partner[i].uuid, "partner[i].uuid")
    console.log(props.partner_uuid, partner[i].uuid, "partner[i]sdad");

    if (partner[i].uuid === props.partner_uuid) {
      array3.push(partner[i]);
      console.log(array3, "partner[i]");

    }
  }

  useEffect(() => {
    const setResponsiveness = () => {
      if (window.innerWidth < 767) {
        setMobileView(true);
      } else {
        setMobileView(false);
        setaccordian(true);
      }
    };

    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());
    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);

  useEffect(() => {
    setCheckedState(new Array(props.value.data.length).fill(false));
  }, [props.value.data]);

  useEffect(() => {
    try {
      if (IsSelectedall === true) {
        if (checkedState.includes(false)) {
          setIsSelectedall(false);
        }
      } else {
        if (!checkedState.includes(false)) {
          setIsSelectedall(true);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }, [checkedState, IsSelectedall]);

  const handleOnChange = (position, val) => {
    SetAddItemText(checkedState[position]);
    const updatedCheckedState = checkedState.map((item, index) =>
      index === position ? !item : item
    );
    console.log(updatedCheckedState, "updatedCheckedState");
    props.handleRadio(
      props.value.data[position].uuid,
      props.value.data[position]
    );
    setCheckedState(updatedCheckedState);
    SetAddItem(true);
  };

  const selectallFn = async (e) => {
    console.log(e, "sgdsdjh")
    setSelectallcard(e.target.checked);
    setIsSelectedall(e.target.checked);
    let temp = [];
    temp = props.value.data;
    console.log(temp, "temp");
    setRadiovalue(temp, e.target.checked);

    if (e.target.checked === true) {
      SetAddItemText(false);
      setCheckedState(new Array(props.value.data.length).fill(true));
      if (props.homeserve == true) {
        setIsHomeSampleSelected(true);
        props.homeServiceArray.map((ite, ind) => {
          // console.log(ite.diagnosticspartner, partnername, "temp");

          if (ite.diagnosticspartner === partnername) {
            HomeServicehandleRadio(true, ite.uuid, ite);
            // if(props.homeserve11 == true){
            //   temp.push(ite);
            // }
            if (temp.length < 2 && props.homeserve11 == true) {
              temp.push(ite);
            }
            else if (temp.length >= 2) {
              temp.push(ite);
            }
            setRadiovalue(temp, true);
          }
        });
      }
    } else {
      SetAddItemText(true);
      setCheckedState(new Array(props.value.data.length).fill(false));
      if (props.homeserve == true) {
        setIsHomeSampleSelected(false);
        props.homeServiceArray.map((ite, ind) => {
          if (ite.diagnosticspartner === partnername) {
            HomeServicehandleRadio(false, ite.uuid, ite);
            //             if(props.homeserve11 == true){
            //   temp.push(ite);
            // }
            if (temp.length < 2 && props.homeserve11 == true) {
              temp.push(ite);
            }
            else if (temp.length >= 2) {
              temp.push(ite);
            }
            setRadiovalue(temp, false);
          }
        });
      }
    }
    SetAddItem(true);
    props.handleAllTestsSelect(
      props.ind,
      props.value.diagnosticspartner,
      e.target.checked
    );
  };

  useEffect(() => {
    if (
      props.value !== undefined &&
      props.value.diagnosticspartner !== undefined
    ) {
      setPartnerName(props.value.diagnosticspartner);
      fetchLocationList(props.value.diagnosticspartner);
    }
  }, []);

  useEffect(() => {
    let data = [];

    let result = [];
    radiotwo.length > 0 &&
      radiotwo.forEach(function (a) {
        console.log(a, "wfedew")
        console.log(this[a.diagnosticspartner], "result")

        if (
          !this[a.diagnosticspartner] &&
          !Number(this[a.doctallsexclusivediscountedprice]) &&
          !Number(this[a.labretailprice])
        ) {
          this[a.diagnosticspartner] = {
            diagnosticspartner: a.diagnosticspartner,
            doctallsexclusivediscountedprice: 0,
            labretailprice: 0,
          };
          result.push(this[a.diagnosticspartner]);
        }
        // else{

        //   const numv = this[a.diagnosticspartner].doctallsexclusivediscountedprice
        //   this[a.diagnosticspartner] = {
        //     diagnosticspartner: a.diagnosticspartner,
        //     doctallsexclusivediscountedprice: Number(numv) + Number(
        //       a.doctallsexclusivediscountedprice
        //     ),
        //     labretailprice: 0,
        //   };
        //   result.push(this[a.diagnosticspartner]);

        // }
        this[a.diagnosticspartner].doctallsexclusivediscountedprice += Number(Number(
          a.doctallsexclusivediscountedprice
        ).toFixed());
        // console.log(resu, "result")

        this[a.diagnosticspartner].labretailprice += Number(a.labretailprice);
      }, Object.create(null));

    setUpdate(!update);
    setCountResult(result);
  }, [radiotwo, props.homeserve]);

  useEffect(() => {
    let totalPrice =
      radiothree.length > 0 &&
      radiothree.reduce(function (item) {
        return Number(item.doctallsexclusivediscountedprice);
      }, 0);
    let totalPricetwo =
      radiothree.length > 0 &&
      radiothree.reduce(function (item) {
        return Number(item.labretailprice);
      }, 0);
    setUpdate(!update);
    setCheapestcount(totalPrice);
    setCheapestcounttwo(totalPricetwo);
  }, [radiothree]);

  useEffect(() => {
    let totalPrice =
      amountarr.length > 0 &&
      amountarr.reduce(function (item) {
        return Number(item.doctallsexclusivediscountedprice);
      }, 0);
    setUpdate(!update);
    setTotalamount(totalPrice);
  }, [amountarr]);

  const addcartfn = async (tests, homeservice, brandname) => {
    const filterarrtest = tests.filter(
      (tes) => tes.diagnosticspartner == brandname
    );
    const filterdhomeservice = homeservice.filter(
      (ser) => ser.diagnosticspartner == brandname
    );
    let temper = [...checkoutdisplay];
    let resulttest;
    let resulthome;
    resulttest =
      temper[props.ind] != undefined &&
      temper[props.ind].testData != undefined &&
      temper[props.ind].testData.some((o1) =>
        filterarrtest.some((o2) => o1.uuid === o2.uuid)
      );
    resulthome =
      temper[props.ind] != undefined &&
      temper[props.ind].homeService != undefined &&
      temper[props.ind].homeService.some((o1) =>
        filterdhomeservice.some((o2) => o1.uuid === o2.uuid)
      );
    if (resulttest == true || resulthome == true) {
      temper[props.ind].testData = [];
      temper[props.ind].homeService = [];
      temper[props.ind].testData.push(...filterarrtest);
      temper[props.ind].homeService.push(...filterdhomeservice);
      let result = Array.from(
        new Set(temper[props.ind].testData.map((s) => s.uuid))
      ).map((id) => {
        return {
          area: temper[props.ind].testData.find((s) => s.uuid === id).area,
          areaRef: temper[props.ind].testData.find((s) => s.uuid === id)
            .areaRef,
          diagnosticspartner: temper[props.ind].testData.find(
            (s) => s.uuid === id
          ).diagnosticspartner,
          discountofferedforretail: temper[props.ind].testData.find(
            (s) => s.uuid === id
          ).discountofferedforretail,
          doctallsexclusivediscountedprice: temper[props.ind].testData.find(
            (s) => s.uuid === id
          ).doctallsexclusivediscountedprice,
          doctallspurchasingprice: temper[props.ind].testData.find(
            (s) => s.uuid === id
          ).doctallspurchasingprice,
          homeserviceavailability: temper[props.ind].testData.find(
            (s) => s.uuid === id
          ).homeserviceavailability,
          labretailprice: temper[props.ind].testData.find((s) => s.uuid === id)
            .labretailprice,
          partnerlabtat: temper[props.ind].testData.find((s) => s.uuid === id)
            .partnerlabtat,
          partnerlabtatindays: temper[props.ind].testData.find(
            (s) => s.uuid === id
          ).partnerlabtatindays,
          partnerstestname: temper[props.ind].testData.find(
            (s) => s.uuid === id
          ).partnerstestname,
          populartest_y_n: temper[props.ind].testData.find((s) => s.uuid === id)
            .populartest_y_n,
          populartestdescription: temper[props.ind].testData.find(
            (s) => s.uuid === id
          ).populartestdescription,
          productcode: temper[props.ind].testData.find((s) => s.uuid === id)
            .productcode,
          standardiseddoctalltat: temper[props.ind].testData.find(
            (s) => s.uuid === id
          ).standardiseddoctalltat,
          standardisedtestname: temper[props.ind].testData.find(
            (s) => s.uuid === id
          ).standardisedtestname,
          testdiscipline: temper[props.ind].testData.find((s) => s.uuid === id)
            .testdiscipline,
          testname_uuid: temper[props.ind].testData.find((s) => s.uuid === id)
            .testname_uuid,
          uuid: temper[props.ind].testData.find((s) => s.uuid === id).uuid,
        };
      });
      let serviceres = Array.from(
        new Set(temper[props.ind].homeService.map((s) => s.uuid))
      ).map((id) => {
        return {
          active: true,
          area: temper[props.ind].homeService.find((s) => s.uuid === id).area,
          areaRef: temper[props.ind].homeService.find((s) => s.uuid === id)
            .areaRef,
          createdAt: temper[props.ind].homeService.find((s) => s.uuid === id)
            .createdAt,
          diagnosticspartner: temper[props.ind].homeService.find(
            (s) => s.uuid === id
          ).diagnosticspartner,
          discountofferedforretail: temper[props.ind].homeService.find(
            (s) => s.uuid === id
          ).discountofferedforretail,
          doctallsexclusivediscountedprice: temper[props.ind].homeService.find(
            (s) => s.uuid === id
          ).doctallsexclusivediscountedprice,
          doctallspurchasingprice: temper[props.ind].homeService.find(
            (s) => s.uuid === id
          ).doctallspurchasingprice,
          homeserviceavailability: temper[props.ind].homeService.find(
            (s) => s.uuid === id
          ).homeserviceavailability,
          labretailprice: temper[props.ind].homeService.find(
            (s) => s.uuid === id
          ).labretailprice,
          partnerlabtat: temper[props.ind].homeService.find(
            (s) => s.uuid === id
          ).partnerlabtat,
          partnerlabtatindays: temper[props.ind].homeService.find(
            (s) => s.uuid === id
          ).partnerlabtatindays,
          partnerstestname: temper[props.ind].homeService.find(
            (s) => s.uuid === id
          ).partnerstestname,
          populartest_y_n: temper[props.ind].homeService.find(
            (s) => s.uuid === id
          ).populartest_y_n,
          populartestdescription: temper[props.ind].homeService.find(
            (s) => s.uuid === id
          ).populartestdescription,
          productcode: temper[props.ind].homeService.find((s) => s.uuid === id)
            .productcode,
          standardiseddoctalltat: temper[props.ind].homeService.find(
            (s) => s.uuid === id
          ).standardiseddoctalltat,
          standardisedtestname: temper[props.ind].homeService.find(
            (s) => s.uuid === id
          ).standardisedtestname,
          testdiscipline: temper[props.ind].homeService.find(
            (s) => s.uuid === id
          ).testdiscipline,
          updatedAt: temper[props.ind].homeService.find((s) => s.uuid === id)
            .updatedAt,
          uuid: temper[props.ind].homeService.find((s) => s.uuid === id).uuid,
        };
      });
      temper[props.ind].testData = result;
      temper[props.ind].homeService = serviceres;
    } else {
      if (
        temper[props.ind] != undefined &&
        temper[props.ind].testData != undefined &&
        temper[props.ind].homeService != undefined
      ) {
        temper[props.ind].testData = [];
        temper[props.ind].homeService = [];
        temper[props.ind].testData.push(...filterarrtest);
        temper[props.ind].homeService.push(...filterdhomeservice);
      }
    }

    setCheckoutdisplay([...new Set(temper)]);
  };
  useEffect(() => {
    addcartfn(radiovalue, props.homeSelection, props.value.diagnosticspartner);
  }, [props.refresh]);

  const hampleSamplePopup = (radiovalue, homeSelection, diagnosticspartner) => {
    setPartnerNames(diagnosticspartner);
    let data = [];

    radiovalue &&
      radiovalue.map((item) => {
        if (item.diagnosticspartner === diagnosticspartner) {
          if (item.homeserviceavailability !== "AVAILABLE") {
            console.log(item.homeserviceavailability);
            data.push(item);
          }
        }
      });

    if (
      radiovalue &&
      radiovalue.length === 1 &&
      radiovalue[0] &&
      radiovalue[0].standardisedtestname === "Home Service Charge"
    ) {
      setAlertInfo(true);
    } else {
      if (isHomeSampleSelected) {
        if (data.length > 0) {
          setHomeSamplePopUp(true);
          setAlertInfo(false);
        } else {
          // setAlertInfo(true);
          addcartfn(radiovalue, homeSelection, diagnosticspartner);
        }
      } else {
        addcartfn(radiovalue, homeSelection, diagnosticspartner);

        setAlertInfo(false);
      }
    }
  };
  let homeSampleAvailable = [];

  useEffect(() => {
    props.value.data.map((val, ind) => {
      console.log(val, "ajgvhga")

      homeSampleAvailable.push(val.homeserviceavailability);
    });
    if (homeSampleAvailable.includes("AVAILABLE")) {
      setShowHomeSample(true);
      setHomeAvailable(true);
    } else {
      setShowHomeSample(false);
      setHomeAvailable(false);
    }
  }, []);


  var selectedValues = [];

  const HomeServicehandleRadio = (e, uuid, ite) => {
    console.log(typeof e, e, uuid, ite, "fdfs")
    if (typeof e === "boolean") {
      setIsHomeSampleSelected(e);
    } else {
      setIsHomeSampleSelected(e.target.checked);
    }
    props.HomeServicehandleRadio(uuid, ite);
  };

  useEffect(() => {
    // HomeServicehandleRadio(false, '', '')
    let data = [];
    if (props.homeserve === false) {
      setIsHomeSampleSelected(false);

      radiotwo &&
        radiotwo.map((item, index) => {
          if (!item.uuid.toString().startsWith("LPHS")) {
            data.push(item);
          }
        });

      setRadiotwo(data);
    }
  }, [props.homeserve]);

  return (
    <>
      <div className="price-container" key={props.ind + "card-outer"}>
        <div className="container-price-card">
          <div className="row-top-cls">
            <div className="row-top-out-cont">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  width: "90%",
                  marginBottom: "20px",
                }}
              >
                {/* {props.value.diagnosticspartner == "SYNLAB" ? (
                  <img src={Synlabbrand} alt="Synlabbrand" />
                ) : props.value.diagnosticspartner == "ECHOLAB" ? (
                  <img src={Echobrand} alt="Echobrand" />
                ) : props.value.diagnosticspartner == "UNION DIAGNOSTICS" ? (
                  <img src={Unionbrand} alt="Unionbrand" />
                ) : props.value.diagnosticspartner == "IMAGE DIAGNOSTICS" ? (
                  <img src={Imagebrand} alt="Imagebrand" />
                ) : props.value.diagnosticspartner == "DNA LABS" ? (
                  <img src={Dnabrand} alt="Dnabrand" />
                ) : props.value.diagnosticspartner == "CLINIX" ? (
                  <img src={Clinixbrand} alt="Clinixbrand" />
                ) : props.value.diagnosticspartner == "CLINA LANCET" ? (
                  <img src={Lancetbrand} alt="Lancetbrand" />
                ) : props.value.diagnosticspartner == "AFRIGLOBAL" ? (
                  <img src={Afribrand} alt="Afribrand" />
                ) : props.value.diagnosticspartner == "DOCTALL" ? (
                  <img src={Docbrand} alt="Docbrand" />
                ) : (
                  <div className="heading-font">
                    {props.value.diagnosticspartner}
                  </div>
                )} */}
                {array3.map((item) => {
                  console.log(item, "logo")
                  return <img src={item.logo}></img>;
                })}

                {/* {(mobileView && (
                  <img
                    src={accordian ? OpenDrop : Drop}
                    alt="dropdown"
                    onClick={() => setaccordian(!accordian)}
                    style={{ width: 25, cursor: "pointer", marginLeft: 30 }}
                  />
                )) ||
                  ""} */}
              </div>
              <div
                style={{
                  cursor: "pointer",
                  justifyContent: "center",
                  alignSelf: "center",
                  display: "flex",
                  color: "#0C44AC",
                  marginBottom: "20px",
                }}
                onClick={() => {
                  window.scroll(0, 500);
                  setLocationPopup(!locationPopup);
                }}
              >
                VIEW LOCATIONS
              </div>
            </div>
          </div>

          {accordian ? (
            <>
              <Toast
                text={
                  addItemText
                    ? "Item(s) removed successfully"
                    : "Item(s) added successfully"
                }
                type="success"
                open={addItem}
                setClose={() => {
                  SetAddItem(false);
                }}
              />

              <div className="select-all-header">
                <div className="check-box">
                  <input
                    type="checkbox"
                    name="compareProduct"
                    onChange={(e) => selectallFn(e)}
                    value={props.value.data}
                    checked={IsSelectedall}
                  />
                </div>
                <div className="select-all-font">Select All</div>
                {recommendedpartneruuid == diagnosticspartner && (
                  <div
                    style={{
                      color: "blue",
                      backgroundColor: "#ADD8E6",
                      margin: "5px",
                      padding: "5px",
                      marginLeft: "19%",
                      borderRadius: "5px",
                    }}
                  >
                    {" "}
                    <img
                      src={DoctorProfile}
                      alt="doctorProfile"
                      color="#ADD8E6"
                    ></img>
                    Recomended Partner
                  </div>
                )}
              </div>
              {props.value &&
                props.value.data != undefined &&
                props.value.data.length > 0 &&
                props.value.data
                  .filter(
                    (item, i) =>
                      item.standardisedtestname != "Home Service Charge"
                  )
                  .map((val, ind) => {
                    return (
                      <>
                        <div
                          className="test-content-cont"
                          key={val.uuid + "index"}
                        >
                          <div className="check-box-start">
                            <input
                              style={{ marginTop: "5%" }}
                              type="checkbox"
                              name="selectTest"
                              onChange={() =>
                                handleOnChange(ind, props.value.data)
                              }
                              value={props.value.data}
                              checked={checkedState && checkedState[ind]}
                            />
                          </div>
                          <PriceCompareTests
                            key={ind}
                            index={ind}
                            val={val}
                            radiovalue={radiovalue}
                            selectallcard={selectallcard}
                            mobileView={mobileView}
                            handleRadio={props.handleRadio}
                            recommendedTest={recommendedTest}
                            recommendedpartneruuid={recommendedpartneruuid}
                          />
                        </div>
                      </>
                    );
                  })}

              {showHomeSample &&
                props.homeServiceArray.find(
                  (o) => o.diagnosticspartner === partnername
                )
                ? props.homeServiceArray.length > 0 &&
                props.homeServiceArray
                  .filter((i) => i.areaRef === areaState.value)
                  .map((ite, ind) => {
                    { console.log(ite, "homeserviceavailability") }
                    if (ite.diagnosticspartner === partnername) {
                      return (
                        <div
                          className={
                            props.homeserve == true
                              ? "home-service-cont"
                              : "home-service-cont dis-cls"
                          }
                          key={ind + "homeservice"}
                        >
                          <div
                            className="check-box-start"
                            style={{ marginLeft: "19px" }}
                          >
                            <input
                              type="checkbox"
                              name="compareProduct"
                              onChange={(e) =>
                                HomeServicehandleRadio(e, ite.uuid, ite)
                              }
                              value={ite}
                              checked={isHomeSampleSelected}
                            />
                          </div>

                          {mobileView ? (
                            <div className="wrapper">
                              <div className="home-service-left">
                                <div className="top-text">
                                  Home Sample Collection{" "}
                                </div>
                                <div className="info-text">
                                  <div
                                    className="info-font"
                                    style={{ color: "white" }}
                                  ></div>
                                </div>
                              </div>
                              <div className="end-cont">
                                <div className="header-price" style={{textAlign:"end"}}>
                                  ₦
                                  {Number(
                                    ite.doctallsexclusivediscountedprice
                                  ).toFixed()}
                                </div>{" "}
                                <div className="sub-header-price-cont" style={{display:"flex",justifyContent:"space-between"}}>
                                  <div>
                                    {ite.discountofferedforretail * 100 === 0 ? "" :
                                      <div style={{textDecorationLine:"line-through",fontSize:"14px",lineHeight:"18px",color:"#717782",fontStyle:"normal",margin:"8px"}}>
                                        ₦
                                        {Number(ite.labretailprice).toFixed()}
                                      </div>
                                    }



                                  </div>
                                  <div >
                                      <span style={{
                                        maxWidth: "39px",
                                        height: "26px",
                                        background: "#fceac5",
                                        borderRadius: "2px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontWeight: "500",
                                        fontSize: "12px",
                                        lineHeight: "15px",
                                        color: "#f78b0c",
                                      }}>
                                        {/* &nbsp;-
                                  {ite.discountofferedforretail &&
                                    ite.discountofferedforretail * 100}
                                  %&nbsp; */}
                                        {ite.discountofferedforretail * 100 === 0 ? "" : "-"}
                                        {ite.discountofferedforretail &&
                                          ite.discountofferedforretail * 100 === 0 ? "" : ite.discountofferedforretail * 100}
                                        {ite.discountofferedforretail * 100 === 0 ? "" : "% "}
                                      </span>
                                    </div>

                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="home-service-left">
                                {alertInfo ? (
                                  <div
                                    className="top-text"
                                    style={{ marginLeft: "5%" }}
                                  >
                                    Home Sample Collection{" "}
                                  </div>
                                ) : (
                                  <div className="top-text">
                                    Home Sample Collection{" "}
                                  </div>
                                )}

                                {alertInfo === true && (
                                  <div
                                    className="info-text"
                                    style={{ width: "120%" }}
                                  >
                                    <img src={AlertInfo} alt="AlertInfo" />
                                    <div className="info-font">
                                      <b className="info-font">
                                        Please select other test with home
                                        sample collection to proceed{" "}
                                      </b>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="total-amount-cont" style={{ border: "none" }}>
                                <div className="header-amt-row">
                                  <div className="left-cls">
                                    <div className="right-cls-cont">
                                      <div className="top-font">
                                        {/* <div className="home-service-right"> */}
                                        ₦
                                        {Number(
                                          ite.doctallsexclusivediscountedprice
                                        ).toFixed()}
                                      </div>{" "}
                                      <div style={{ display: "flex", justifyContent: "space-around" }}>
                                        {ite.discountofferedforretail * 100 === 0 ? "" :
                                          <div className="bottom-font">
                                            ₦
                                            {Number(ite.labretailprice).toFixed()}
                                          </div>
                                        }
                                        <div>
                                          <span style={{
                                            maxWidth: "39px",
                                            height: "26px",
                                            background: "#fceac5",
                                            borderRadius: "2px",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            fontWeight: "500",
                                            fontSize: "12px",
                                            lineHeight: "15px",
                                            color: "#f78b0c",
                                            marginLeft: "10px"
                                          }}>
                                            {ite.discountofferedforretail * 100 === 0 ? "" : "-"}
                                            {ite.discountofferedforretail &&
                                              ite.discountofferedforretail * 100 === 0 ? "" : ite.discountofferedforretail * 100}
                                            {ite.discountofferedforretail * 100 === 0 ? "" : "% "}
                                          </span>
                                        </div>
                                      </div>
                                      {/* </div> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )
                          }
                        </div>
                      );
                    } else {
                      return "";
                    }
                  })
                : null}
              <div className="total-amount-cont">
                <div className="header-amt-row">
                  <div className="left-cls">Selected Test(s) Cost</div>
                  <div className="right-cls-cont">
                    <div className="top-font">
                      {countresult.find(
                        (o) => o.diagnosticspartner == partnername
                      )
                        ? countresult.length > 0 &&
                        countresult.map((ite, ind) => {
                          console.log(ite, "sdfd")
                          if (ite.diagnosticspartner == partnername) {
                            return (
                              "₦" +
                              Number(
                                ite.doctallsexclusivediscountedprice
                              ).toFixed()
                              // Number(
                              //   ite.doctallsexclusivediscountedprice
                              // )
                            );
                          }
                        })
                        : ""}
                    </div>
                    <div className="bottom-font">
                      {countresult.find(
                        (o) => o.diagnosticspartner == partnername
                      )
                        ? countresult.length > 0 &&
                        countresult.map((ite, ind) => {
                          console.log(ite, "sdfd")
                          if (ite.diagnosticspartner == partnername) {
                            return "₦" +
                              Number(ite.labretailprice).toFixed();
                            // Number(ite.labretailprice);
                          }
                        })
                        : ""}
                    </div>
                  </div>
                </div>
                <div className="footer-cont">
                  <span>
                    {" "}
                    Today you save ₦
                    {(radiovalue.length !== 0 &&
                      radiovalue
                        .filter(
                          (i) =>
                            i.diagnosticspartner ===
                            props.value.diagnosticspartner
                        )
                        .map((item) => parseInt(item.labretailprice))
                        .reduce((a, b) => a + b, 0) -
                      radiovalue
                        .filter(
                          (i) =>
                            i.diagnosticspartner ===
                            props.value.diagnosticspartner
                        )
                        .map((item) =>
                          parseInt(item.doctallsexclusivediscountedprice)
                          // item.doctallsexclusivediscountedprice
                        )
                        .reduce((a, b) => a + b, 0)) ||
                      0}
                  </span>
                </div>
              </div>
              <div
                className="cart-btn"
                onClick={() => {
                  hampleSamplePopup(
                    radiovalue,
                    props.homeSelection,
                    props.value.diagnosticspartner
                  );
                }}
              >
                <span>Add to Cart</span>
              </div>
            </>
          ) : (
            <div className="unselectedacc">
              <div className="left-cls">Selected Test(s) Cost</div>
              <div className="right-cls-cont">
                <div className="top-font">
                  {countresult.find((o) => o.diagnosticspartner == partnername)
                    ? countresult.length > 0 &&
                    countresult.map((ite, ind) => {
                      console.log(ite, "itennnnnnnnnnn")
                      if (ite.diagnosticspartner == partnername) {
                        return (
                          "₦" +
                          Number(
                            ite.doctallsexclusivediscountedprice
                          ).toFixed()
                        );
                      }
                    })
                    : ""}
                </div>
                <div className="bottom-font">
                  {countresult.find((o) => o.diagnosticspartner == partnername)
                    ? countresult.length > 0 &&
                    countresult.map((ite, ind) => {
                      if (ite.diagnosticspartner == partnername) {
                        return "₦" + Number(ite.labretailprice).toFixed();
                      }
                    })
                    : ""}
                </div>
              </div>
            </div>
          )}
        </div>
      </div >

      <Modal
        show={showHomeSamplePopup}
        onHide={() => {
          setHomeSamplePopUp(false);
        }}
      >
        <div className="parentContainer">
          <div>
            <Modal.Header>
              {mobileView === true ? (
                <div>
                  <br></br>
                  <span className="hs-header1">Important Notice</span>
                  <br></br>
                </div>
              ) : (
                <span className="hs-header">Important Notice</span>
              )}
              <div
                style={{ cursor: "pointer" }}
                className="labmodal_close"
                onClick={() => {
                  setHomeSamplePopUp(false);
                }}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 15L15 1M1 1L15 15L1 1Z"
                    stroke="black"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </Modal.Header>
          </div>
          <br></br>
          <div>
            Check if Home Service Sample Collection is available for the tests you have selected. If it's available, you can schedule a home visit for sample collection. However, if Home Service is not available for a particular test, you must visit the Laboratory partner in person to provide your sample.<br></br>
            <br></br>
            <b>Diagnostic Partner : {partnerNames}</b>
            <table style={{ marginTop: "3%" }}>
              <tr>
                <th>TEST</th>
                <th>HOME SERVICE AVAILABILITY</th>
              </tr>
              {radiovalue.map((val) => {
                if (val.standardisedtestname != "Home Service Charge") {
                  if (val.diagnosticspartner == partnerNames) {
                    return (
                      <tr style={{ height: "45px" }}>
                        <td>
                          {" "}
                          <p style={{ margin: "1%" }}>
                            {" "}
                            {val.standardisedtestname}
                          </p>
                        </td>
                        <td
                          style={{
                            fontWeight: 600,
                            color:
                              val.homeserviceavailability === "AVAILABLE"
                                ? "#11A666"
                                : "#E24349",
                          }}
                        >
                          <p style={{ margin: "1%" }}>
                            {" "}
                            {val.homeserviceavailability}
                          </p>
                        </td>
                      </tr>
                    );
                  } else {
                    return null;
                  }
                }
              })}
            </table>
          </div>
          <Modal.Footer
            style={{
              marginTop: "25px",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <span className="popup_btn_hs_ftr">Do you wish to proceed ?</span>
            <div style={{ display: "flex" }}>
              <button
                className="popup_btn_hs_yes"
                style={{ borderColor: "#ffffff" }}
                onClick={() => {
                  setHomeSamplePopUp(false);
                  addcartfn(
                    radiovalue,
                    props.homeSelection,
                    props.value.diagnosticspartner
                  );
                }}
              >
                Yes
              </button>
              <button
                className="popup_btn_hs"
                style={{ borderColor: "#ffffff" }}
                onClick={() => {
                  setHomeSamplePopUp(false);
                }}
              >
                No
              </button>
            </div>
          </Modal.Footer>
        </div>
      </Modal>

      <Modal
        dialogClassName="modal-size"
        show={locationPopup}
        onHide={() => {
          setLocationPopup(false);
        }}
      >
        <>
          {!mobileView && (
            <div
              className="parentContainer"
              style={{
                padding: "0px",
                marginLeft: "auto !important",
                marginTop: "10%",
                position: "relative",
                //  width:"65%",
                // marginLeft:"3%"
              }}
            >
              <Modal.Header style={{ padding: "0px" }}>
                <div className="modal_header">
                  {/* {props.value.diagnosticspartner == "SYNLAB" ? (
                    <img src={Synlabbrand} alt="Synlabbrand" />
                  ) : props.value.diagnosticspartner == "ECHOLAB" ? (
                    <img src={Echobrand} alt="Echobrand" />
                  ) : props.value.diagnosticspartner == "UNION DIAGNOSTICS" ? (
                    <img src={Unionbrand} alt="Unionbrand" />
                  ) : props.value.diagnosticspartner == "IMAGE DIAGNOSTICS" ? (
                    <img src={Imagebrand} alt="Imagebrand" />
                  ) : props.value.diagnosticspartner == "DNA LABS" ? (
                    <img src={Dnabrand} alt="Dnabrand" />
                  ) : props.value.diagnosticspartner == "CLINIX" ? (
                    <img src={Clinixbrand} alt="Clinixbrand" />
                  ) : props.value.diagnosticspartner == "CLINA LANCET" ? (
                    <img src={Lancetbrand} alt="Lancetbrand" />
                  ) : props.value.diagnosticspartner == "AFRIGLOBAL" ? (
                    <img src={Afribrand} alt="Afribrand" />
                  ) : props.value.diagnosticspartner == "DOCTALL" ? (
                    <img src={Docbrand} alt="Docbrand" />
                  ) : (
                    <div className="heading-font">
                      {props.value.diagnosticspartner}
                    </div>
                  )} */}
                  {array3.map((item) => {
                    return <img src={item.logo} style={{ width: "140px", height: "auto" }}></img>;
                  })}
                </div>
                <div
                  style={{ cursor: "pointer" }}
                  className="labmodal_close"
                  onClick={() => {
                    setLocationPopup(false);
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 15L15 1M1 1L15 15L1 1Z"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </Modal.Header>
              {locations && locations.length > 0 ? (
                <div className="modal_subhead">

                  <span>
                    {/* {`Please find the different addresses of our Lab partner in ${areaState && areaState.label
                      }
                below`} */}
                    {`Please find the different addresses of our Lab partner below`}
                  </span>
                </div>
              ) : (
                <div className="modal_subhead">
                  <span>
                    {/* {`No addresses found for our Lab partner in ${areaState && areaState.label
                      }`} */}
                    {`No addresses found for our Lab partner `}
                  </span>
                </div>
              )}

              <div style={{ margin: "3%", width: "150%" }}>
                {console.log(locations, "locations")}
                <LocationList locations={locations} />
              </div>
              {/* {locations && locations.length > 0 && (
                <span className="branch_link">
                  See complete list of branches nationwide
                </span>
              )} */}
            </div>
          )}
          {mobileView && (
            <div
              className="parentContainer"
              style={{
                // padding: "0px",
                marginLeft: "auto !important",
                marginTop: "10%",
                position: "relative",
                width: "65%",
                marginLeft: "2%",
                height: "auto",
              }}
            >
              <Modal.Header style={{ padding: "0px" }}>
                <div className="modal_header">
                  {console.log(props.value.diagnosticspartner, "oputttt")}
                  {props.value.diagnosticspartner == "SYNLAB" ? (
                    <img src={Synlabbrand} alt="Synlabbrand" />
                  ) : props.value.diagnosticspartner == "ECHOLAB" ? (
                    <img src={Echobrand} alt="Echobrand" />
                  ) : props.value.diagnosticspartner == "UNION DIAGNOSTICS" ? (
                    <img src={Unionbrand} alt="Unionbrand" />
                  ) : props.value.diagnosticspartner == "IMAGE DIAGNOSTICS" ? (
                    <img src={Imagebrand} alt="Imagebrand" />
                  ) : props.value.diagnosticspartner == "DNA LABS" ? (
                    <img src={Dnabrand} alt="Dnabrand" />
                  ) : props.value.diagnosticspartner == "CLINIX" ? (
                    <img src={Clinixbrand} alt="Clinixbrand" />
                  ) : props.value.diagnosticspartner == "CLINA LANCET" ? (
                    <img src={Lancetbrand} alt="Lancetbrand" />
                  ) : props.value.diagnosticspartner == "AFRIGLOBAL" ? (
                    <img src={Afribrand} alt="Afribrand" />
                  ) : props.value.diagnosticspartner == "DOCTALL" ? (
                    <img src={Docbrand} alt="Docbrand" />
                  ) : (
                    <div className="heading-font">
                      {props.value.diagnosticspartner}
                    </div>
                  )}
                </div>
                <div
                  style={{ cursor: "pointer" }}
                  className="labmodal_close"
                  onClick={() => {
                    setLocationPopup(false);
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 15L15 1M1 1L15 15L1 1Z"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </Modal.Header>

              {locations && locations.length > 0 ? (

                <div className="modal_subhead">
                  {console.log(locations)}
                  <span>
                    {`Please find the different addresses of our Lab partner in ${areaState && areaState.label
                      }
              below`}
                  </span>
                </div>
              ) : (
                <div className="modal_subhead">
                  <span>
                    {`No addresses found for our Lab partner in ${areaState && areaState.label
                      }`}
                  </span>
                </div>
              )}

              <div style={{ margin: "3%" }}>
                <LocationList locations={locations} />
              </div>
              {/* {locations && locations.length > 0 && (
                <span className="branch_link">
                  See complete list of branches nationwide
                </span>
              )} */}
            </div>
          )}
        </>
      </Modal>
    </>
  );
}
